
export const idPhotoGeneration = {
    toolName: '证件照生成',
    toolDescription: '将您的照片转换为标准的证件照，支持多种尺寸和背景颜色',
    
    uploadImage: '上传照片',
    uploadImageDescription: '上传一张清晰的人像照片，支持 JPG、PNG 格式',
    clickOrDragUpload: '点击或拖拽上传照片',
    
    photoSize: '照片尺寸',
    photoSizeDescription: '选择您需要的证件照尺寸',
    
    backgroundColor: '背景颜色',
    backgroundColorDescription: '选择证件照的背景颜色',
    
    sizes: {
      oneInch: {
        name: '一寸照',
        desc: '2.5cm × 3.5cm，常用于身份证、学生证等'
      },
      twoInch: {
        name: '二寸照',
        desc: '3.5cm × 5.3cm，常用于护照、签证等'
      },
      passport: '护照照片',
      passportDesc: '3.5cm × 4.5cm，符合护照标准尺寸',
      visa: '签证照片',
      visaDesc: '5.1cm × 5.1cm，符合美国签证标准'
    },
    
    backgroundColors: {
      title: '背景颜色选择'
    },
    
    generateButton: '生成证件照',
    generating: '生成中...',
    generationComplete: '证件照生成完成',
    downloadPhoto: '下载证件照',
    
    tips: {
      title: '拍摄建议',
      items: [
        '请使用清晰的正面照片',
        '确保光线充足，避免阴影',
        '保持自然表情，眼睛直视镜头',
        '避免佩戴帽子或遮挡面部的饰品'
      ]
    }
  };
